import clsx from 'clsx';

import { IChildren } from '@/types';

import AppSidebar from './appSidebar';
import Header from './header';

const AppLayout = ({ children }: IChildren) => {
  return (
    <div className="w-screen h-screen overflow-hidden bg-neutral-light-50 py-4 pe-4">
      <div className="flex w-full h-full gap-4">
        <AppSidebar />
        <div className="flex w-full flex-col max-md:p-2 bg-secondary-foreground min-w-0">
          <div className="rounded-2xl p-6 max-md:p-4 shadow-small border-b border-neutral-50 bg-white h-full w-full flex flex-col no-scrollbar overflow-x-auto min-w-0">
            <Header />
            <div
              className={clsx(
                'flex-1 overflow-x-hidden overflow-y-auto no-scrollbar min-w-0 pt-6',
                'main-container'
              )}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
